//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapState} from 'vuex'
export default {
  name: 'Clinch',
  filters: {
  },
  computed: {
    ...mapGetters(['locale', 'vcListNoSettleEnabled']),
    ...mapState({
      coinListWithPrice: state => state.vc.coinListWithPrice
    }),
    clinchCoinList () {
      if (!this.coinListWithPrice.length || !this.vcListNoSettleEnabled.length) return []
      return this.vcListNoSettleEnabled.map(settleItem => {
        return this.coinListWithPrice.find(coinWithPriceItem => {
          return settleItem.id === coinWithPriceItem.a
        })
      }).filter(item => !!item).sort((pre, next) => next.j - pre.j)
    }
  },
  methods: {
    clickVcItem (currency) {
      this.$store.dispatch('setVcId', currency.a)
        .then(() => {
          this.$router.push('/trade')
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/Ranking/components/Clinch/Clinch.vue